"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const HasValueWidget_1 = tslib_1.__importDefault(require("../widget/HasValueWidget"));
// Component rendered in the user interface
// <div style="display: flex; flex-direction: column">
//   <span>{label}</span>
//   <strong>[value?]</strong>
// </div>
class ReadonlyField extends HasValueWidget_1.default {
    constructor(readonlyFieldArgs) {
        super();
        this.readonlyFieldArgs = readonlyFieldArgs;
        this.element = document.createElement("div");
        this.element.classList.add("readonly-field");
        this.labelElement = document.createElement("span");
        this.setLabel(readonlyFieldArgs.label);
        this.valueElement = document.createElement("strong");
        this.setValue(readonlyFieldArgs.value);
        this.element.appendChild(this.labelElement);
        this.element.appendChild(this.valueElement);
    }
    setLabel(label) {
        this.readonlyFieldArgs.label = label;
        this.labelElement.textContent = label;
    }
    getValue() {
        return this.value;
    }
    setValue(value) {
        this.value = value;
        this.readonlyFieldArgs.value = this.value;
        this.valueElement.textContent = this.value || "-";
    }
    clearValue() {
        super.clearValue();
        this.valueElement.textContent = "-";
    }
}
exports.default = ReadonlyField;
//# sourceMappingURL=ReadonlyField.js.map